import React from "react";
import { Button, createStyles, Grid, makeStyles } from "@material-ui/core";
import { ITourTemplateAxe } from "contexts/RequestQuoteContext";
import { CloseIcon } from "icons";
import { theme } from "config/theme";
import TourPoints from "./TourPoints";

interface Props {
  templateAxe: any;
  onDelete?: (tAxe: ITourTemplateAxe) => void;
  onVehicleButtonClicked?: (tAxe: ITourTemplateAxe) => void;
  onAxeReccurenceButtonClicked?: (tAxe: ITourTemplateAxe) => void;
  index?: number;
}
export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      padding: "40px !important",
      borderWidth: 1,
      borderColor: "gray",
      borderRadius: 12,
      marginBottom: 15,
      border: "solid",
      [theme.breakpoints.down("xs")]: {
        padding: "20px !important",
        borderWidth: 1,
        borderColor: "gray",
        borderRadius: 12,
        marginBottom: 15,
        border: "solid",
      },
    },
    close: {
      float: "right",
      marginRight: -20,
      marginTop: "-30px",
      marginBottom: "10px",
      [theme.breakpoints.down("xs")]: {
        float: "right",
        marginTop: -12,
        marginRight: -10,
      },
    },
  })
);
const TemplateAxe = ({ templateAxe, onDelete, onVehicleButtonClicked, onAxeReccurenceButtonClicked, index }: Props) => {
  const classes = useStyles();
  const handleDelete = () => {
    onDelete(templateAxe);
  };
  const handleSelectVehicle = () => {
    onVehicleButtonClicked(templateAxe);
  };

  const handleReccurence = () => {
    onAxeReccurenceButtonClicked(templateAxe);
  };
  return (
    <Grid item xs={12} className={classes.container}>
        {index !== 0 && (
            <Button onClick={handleDelete} className={classes.close}>
              <CloseIcon />
            </Button>
        )}
        <TourPoints
          onVehicleButtonClicked={handleSelectVehicle}
          onAxeReccurenceButtonClicked={handleReccurence}
          templateAxe={templateAxe}
          index={index}
        />
      </Grid>
  );
};

export default TemplateAxe;
